import api from '@/utils/http/axios'
import { NO_PREFIX_URL } from '@/utils/http/base-url'
import store from '@/store'
export default {
  /**
  * 获取sessionData(客户信息)
  */
  getSessionData (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/getSessionData.do?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config, 'URLEncoded')
  },
  /**
  * 获取menuInfo(权限菜单信息)
  */
  getMenuInfo (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/getMenuInfo.do?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config, 'URLEncoded')
  },
  /**
  * 获取别名alias
  */
  getAlias (params = {}, config = {}) {
    return api.get('api/client/fund/info', params, config)
  },
  /**
  * 获取服务器时间
  */
  getServerDateTime (params = {}, config = {}) {
    return api.get(`${NO_PREFIX_URL}/getServerDateTime.do`, params, config, 'URLEncoded')
  },
  /**
  * 获取操作日志
  */
  getUserLogs (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/getUserLog.do?EMP_SID=${store.state.login.loginInfo.EMP_SID}`, params, config, 'URLEncoded')
  },
  /**
  * 获取待办事项
  */
  getTodoList (params = {}, config = {}) {
    return api.post('/api/auth/statistics', params, config, 'URLEncoded')
  },
  /**
  * 获取账户列表(新接口)
  */
  getAccountList (params = {}, config = {}) {
    return api.post('/api/account/list', params, config, 'URLEncoded')
  },
  /**
  * 获取账户列表(旧接口)
  * @param {string} currentBusinessCode '00000001'
  */
  getUserAccount (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/getUserAccount.do`, params, config, 'URLEncoded')
  },
  /**
  * 获取某一账户余额
  * @param {string} accountNo 账户号
  * @param {string} currentBusinessCode '10100000'
  */
  getUserAccountBalance (params = {}, config = {}) {
    return api.post(`${NO_PREFIX_URL}/accountBalanceQuery.do`, params, config, 'URLEncoded')
  },
  /**
  * 获取城市列表
  */
  getCountryList (params = {}, config = {}) {
    return api.post('/api/sanction/list', params, config, 'URLEncoded')
  },
  /**
  * 获取账户列表(带余额)
  * @param {string} currency 当前币种
  */
  getListAccountWithBalance (params = {}, config = {}) {
    return api.post('/api/account/listAccountWithBalance', params, config, 'URLEncoded')
  },
  /**
  * 查询余额分布
  */
  balanceDistribution (params = {}, config = {}) {
    return api.post('/api/account/balanceDistribution', params, config, 'URLEncoded')
  }
}
